

















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Accordion from "@/components/shared/Accordion.vue";
import ExtraServiceDetail from "./ExtraServiceDetail.vue";
import {
  OnlineMBEExtraServiceDto,
  PaymentTypesDTO,
  ProformaDTO,
  ShipmentDTO,
  ShipmentExtraServiceDTO
} from "@/model/data.model";
import store from "@/vuex/store";
import i18n from "@/lang/i18n";
import VueScrollTo from "vue-scrollto";
import { CustomerService } from "@/services/CustomerService";
import NewShipment from "./NewShipment.vue";

export const MBE_SAFE_VALUE = "MBE SafeValue";
export const MBE_SAFE_VALUE_ESSENTIAL = "MBE SafeValue Essential";
export const INSURANCE_COURIER = "Insurance Courier";
export const COD = "Cash on Delivery";
export const SIGNATURE_REQUIRED = "Signature Required";
export const ADULT_SIGNATURE_REQUIRED = "Adult signature required";
export const SATURDAY_DELIVERY = "Delivery Saturday";
export const PREDICT_SMS_DPD = "Notice Delivery SMS Forecast";
export const PREDICT_EMAIL_DPD = "Notice Delivery e-Mail Forecast";
export const RETURN_PRINT = "Return Print";
export const RETURN_PRINT_AND_SEND = "Return Print and Send";
export const RETURN_ONE_ATTEMPT = "Return One Attempt";
export const RETURN_THREE_ATTEMPTS = "Return Three Attempts";
export const RETURN_ELECTRONIC = "Return Electronic";
export const COVER_PROTECT_G = "Cover Protect (G)";
export const COVER_PROTECT_S = "Cover Protect + Shipment (S/P)";
export const PRIVATE_HOME_DELIVERY = "Private home delivery";
export const UPS_CARBON = "UPS carbon";
export const DIRECT_DELIVERY_ONLY = "Direct delivery only";
export const MBE_SAFE_VALUE_4B = "MBE SafeValue 4Business";
export const DELIVERY_NEUTRAL = "Delivery Neutral";
export const NOTICE_DELIVERY_E_MAIL_BEFORE = "Notice Delivery e-Mail Before";
export const DRY_ICE = "Dry Ice";
export const MBE_MEASUREMENT_FEE = "MBE Measurement fee";
export const GENERIC_ITEM_ID = 0;
export const MBE_SAFEVALUE_ID = 1;
export const CASH_ON_DELIVERY_ID = 2;
export const INSURANCE_COURIER_ID = 3;
export const ACKNOWLEDGMENT_ID = 4;
export const ADDRESS_CORRECTION_ID = 5;
export const CARBON_NEUTRAL_ID = 6;
export const UPS_CARBON_ID = 6;
export const CUSTOM_DUTIES_1_ID = 7;
export const CUSTOM_DUTIES_2_ID = 8;
export const CUSTOM_DUTIES_3_ID = 9;
export const CUSTOM_DUTIES_4_ID = 10;
export const CUSTOM_DUTIES_5_ID = 11;
export const DEDICATED_CUSTOMER_SERVICE_ID = 12;
export const DELIVERED_DUTY_PAID_ID = 13;
export const DELIVERY_APPOINTMENT_ID = 14;
export const DIRECT_DELIVERY_ONLY_ID = 15;
export const DELIVERY_DIRECT_ID = 15;
export const DELIVERY_DOOR_ID = 16;
export const DELIVERY_EVENING_ID = 17;
export const DELIVERY_MORNING_ID = 18;
export const DELIVERY_NEUTRAL_ID = 19;
export const DELIVERY_PRIORITY_ID = 20;
export const PRIORITY_DELIVERY_ID = 20;
export const PRIVATE_HOME_DELIVERY_ID = 21;
export const DELIVERY_PRIVATE_HOME_ID = 21;
export const DELIVERY_SATURDAY_ID = 22;
export const DELIVERY_SCHEDULED_ID = 23;
export const DELIVERY_SCHEDULED_DAY_ID = 24;
export const DELIVERY_SECOND_ATTEMPT_ID = 25;
export const DELIVERY_SECOND_ATTEMPT_APPOINTMENT_ID = 26;
export const DIMENSIONAL_SURCHARGE_1_ID = 27;
export const OVERSIZE_PACKAGE_ID = 27;
export const DIMENSIONAL_SURCHARGE_2_ID = 28;
export const SURCHARGE_BIG_PACKAGES_ID = 28;
export const DIMENSIONAL_SURCHARGE_3_ID = 29;
export const DIMENSIONAL_SURCHARGE_4_ID = 30;
export const DIMENSIONAL_SURCHARGE_5_ID = 31;
export const DRY_ICE_ID = 32;
export const EX_WORKS_ID = 33;
export const EXTENDED_LIABILITY_ID = 34;
export const FRAGILE_ID = 35;
export const FUEL_SURCHARGE_ID = 36;
export const HIGHWAY_TAX_ID = 37;
export const IDENTITY_CHECK_ID = 38;
export const INSURANCE_COURIER_EXTENDED_ID = 39;
export const FULL_INSURANCE_ID = 40;
export const INSURANCE_FULL_ID = 40;
export const INSURANCE_GLOBAL_PACKAGE_ID = 41;
export const INSURANCE_GLOBAL_SHIPMENT_ID = 42;
export const INSURANCE_OTHER_ID = 43;
export const INSURANCE_OTHER_1_ID = 44;
export const INSURANCE_OTHER_2_ID = 45;
export const INSURANCE_OTHER_3_ID = 46;
export const INSURANCE_OTHER_4_ID = 47;
export const INSURANCE_OTHER_5_ID = 48;
export const LIMITED_TRAFFIC_ZONE_ID = 49;
export const MISSING_RECEIVER_ID = 50;
export const MISSING_SENDER_ID = 51;
export const MULTIPACKAGE_MANAGEMENT_ID = 52;
export const NON_PALLETIZED_ID = 53;
export const NON_STACKABLE_ID = 54;
export const NOTICE_DELIVERY_E_MAIL_BEFORE_ID = 55;
export const NOTICE_DELIVERY_E_MAIL_FORECAST_ID = 56;
export const NOTICE_DELIVERY_SMS_BEFORE_ID = 57;
export const NOTICE_DELIVERY_SMS_FORECAST_ID = 58;
export const NOTICE_DELIVERY_TELEPHONE_BEFORE_ID = 59;
export const NOTICE_DELIVERY_TELEPHONE_FORECAST_ID = 60;
export const NOTICE_PICKUP_E_MAIL_BEFORE_ID = 61;
export const NOTICE_PICKUP_E_MAIL_FORECAST_ID = 62;
export const NOTICE_PICKUP_SMS_BEFORE_ID = 63;
export const NOTICE_PICKUP_SMS_FORECAST_ID = 64;
export const NOTICE_PICKUP_TELEPHONE_BEFORE_ID = 65;
export const NOTICE_PICKUP_TELEPHONE_FORECAST_ID = 66;
export const PACKAGING_1_ID = 67;
export const PACKAGING_ID = 67;
export const PACKAGING_2_ID = 68;
export const PACKAGING_3_ID = 69;
export const PACKAGING_4_ID = 70;
export const PACKAGING_5_ID = 71;
export const PICKUP_APPOINTMENT_ID = 72;
export const PICKUP_DOOR_ID = 73;
export const PICKUP_EVENING_ID = 74;
export const PICKUP_MORNING_ID = 75;
export const PICKUP_PRIVATE_HOME_ID = 76;
export const PICKUP_SATURDAY_ID = 77;
export const PICKUP_TELEPHONE_FUTURE_DAY_ID = 78;
export const PICKUP_TELEPHONE_SAME_DAY_ID = 79;
export const PICKUP_WEB_FUTURE_DAY_ID = 80;
export const PICKUP_WEB_SAME_DAY_ID = 81;
export const PRIORITY_BOARDING_ID = 82;
export const PROOF_OF_DELIVERY_DIGITAL_ID = 83;
export const PROOF_OF_DELIVERY_PAPER_ID = 84;
export const QUANTUMVIEW_NOTIFICATION_ID = 85;
export const REMOTE_AREA_1_ID = 86;
export const REMOTE_AREA_ID = 86;
export const REMOTE_AREA_2_ID = 87;
export const REMOTE_AREA_3_ID = 88;
export const REMOTE_AREA_4_ID = 89;
export const REMOTE_AREA_5_ID = 90;
export const REMOTE_COUNTRY_1_ID = 91;
export const REMOTE_COUNTRY_2_ID = 92;
export const REMOTE_COUNTRY_3_ID = 93;
export const RETURN_ELECTRONIC_ID = 94;
export const RETURN_ONE_ATTEMPT_ID = 95;
export const RETURN_PRINT_ID = 96;
export const RETURN_PRINT_AND_SEND_ID = 97;
export const RETURN_THREE_ATTEMPTS_ID = 98;
export const SIGNATURE_REQUIRED_ID = 99;
export const ADULT_SIGNATURE_REQUIRED_ID = 100;
export const SIGNATURE_REQUIRED_ADULT_ID = 100;
export const SPECIAL_HANDLING_ID = 101;
export const ADDIONAL_HANDLING_ID = 101;
export const STATIONARY_STORAGE_ID = 102;
export const STOCK_ID = 103;
export const SUPERMARKETS_AND_MMR_ID = 104;
export const TEMPORARY_IMPORT_EXPORT_ID = 105;
export const THIRD_PARTY_SHIPMENT_ID = 106;
export const UNPAID_CASH_ON_DELIVERY_ID = 107;
export const TYRES_ID = 108;
export const ALCOHOLIC_BEVERAGES_ID = 109;
export const DANGEROUS_GOODS_ID = 110;
export const PEAK_SURCHARGE_ID = 111;
export const RECEIVER_PAYS_ID = 112;
export const ISC_ID = 112;
export const RETURN_OF_UNDELIVERED_SHIPMENT_ID = 112;
export const PICKUP_PRIORITY_ID = 113;
export const NEXT_DAY_TO_09_00_ID = 113;
export const NEXT_DAY_TO_10_00_ID = 114;
export const DELIVERY_DEPARTMENT_ID = 114;
export const NEXT_DAY_TO_12_00_ID = 115;
export const DELIVERY_GUARANTEE_ID = 115;
export const GROUPAGE_PACKAGES_GREATER_TO_5_ID = 115;
export const DELIVERY_1600_ID = 116;
export const DECLARED_VALUE_ID = 116;
export const DELIVERY_1200_ID = 117;
export const CORSICA_DELIVERY_ID = 117;
export const CASH_ON_DELIVERY_EXPRESS_ID = 117;
export const DELIVERY_1000_ID = 118;
export const SWITZERLAND_DELIVERY_ID = 118;
export const DIPLOMATIC_SHIPMENT_ID = 118;
export const DELIVERY_0800_ID = 119;
export const EMPTY_DRIVEWAY_ID = 119;
export const EXTENDED_AREAS_ID = 119;
export const PICKUP_AREA_ID = 120;
export const NOTICE_AMAZON_ID = 120;
export const DELIVERY_ON_RELAY_POINTS_ID = 120;
export const INTERNATIONAL_SPECIAL_COMMODITIES_ID = 121;
export const SPECIAL_COLLECTION_ID = 121;
export const PICKUP_ORDER_ID = 121;
export const ELEVATED_RISK_1_ID = 122;
export const ELEVATED_RISK_2_ID = 123;
export const ELEVATED_RISK_3_ID = 124;
export const SECURITY_FEE_ID = 125;
export const EMERGENCY_SITUATION_ID = 126;
export const MBE_MEASUREMENT_FEE_ID = 241;
export const MBE_SAFEVALUE_4B_ID = 300;
export const MBE_SAFEVALUE_ESSENTIAL_ID = 332;

@Component({
  components: {
    Accordion: Accordion,
    ExtraServiceDetail: ExtraServiceDetail
  }
})
export default class ExtraServices extends Vue {
  definedExtraServices = [
    {
      id_mbe_business: MBE_SAFEVALUE_ID,
      name: MBE_SAFE_VALUE,
      has_value: true,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_safe_value"),
      value_label: i18n.t("extra_service_safe_value_value"),
      description_label: i18n.t("extra_service_safe_value_description")
    },
    {
      id_mbe_business: MBE_SAFEVALUE_ESSENTIAL_ID,
      name: MBE_SAFE_VALUE_ESSENTIAL,
      has_value: true,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_safe_value_essential"),
      value_label: i18n.t("extra_service_safe_value_value_essential"),
      description_label: i18n.t(
        "extra_service_safe_value_essential_description"
      )
    },
    {
      id_mbe_business: MBE_SAFEVALUE_4B_ID,
      name: MBE_SAFE_VALUE_4B,
      has_value: true,
      has_description: false,
      has_payment_type: false,
      value_label: i18n.t("extra_service_safe_value_value"),
      title: MBE_SAFE_VALUE_4B
    },
    {
      id_mbe_business: CASH_ON_DELIVERY_ID,
      name: COD,
      has_value: true,
      has_description: false,
      has_payment_type: true,
      title: i18n.t("extra_service_cod"),
      value_label: i18n.t("extra_service_cod_value"),
      payment_type_label: i18n.t("extra_service_cod_payment_type")
    },
    {
      id_mbe_business: INSURANCE_COURIER_ID,
      name: INSURANCE_COURIER,
      has_value: true,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_insurance"),
      value_label: i18n.t("extra_service_insurance_value")
    },
    {
      id_mbe_business: SIGNATURE_REQUIRED_ID,
      name: SIGNATURE_REQUIRED,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: this.$t("extra_service_signature_required")
    },
    {
      id_mbe_business: ADULT_SIGNATURE_REQUIRED_ID,
      name: ADULT_SIGNATURE_REQUIRED,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: this.$t("extra_service_adult_signature_required")
    },
    {
      id_mbe_business: DELIVERY_SATURDAY_ID,
      name: SATURDAY_DELIVERY,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: this.$t("extra_service_saturday_delivery")
    },
    {
      id_mbe_business: NOTICE_DELIVERY_SMS_FORECAST_ID,
      name: PREDICT_SMS_DPD,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_dpd_predict_sms")
    },
    {
      id_mbe_business: NOTICE_DELIVERY_E_MAIL_FORECAST_ID,
      name: PREDICT_EMAIL_DPD,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_dpd_predict_email")
    },
    {
      id_mbe_business: RETURN_PRINT_ID,
      name: RETURN_PRINT,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_return_print")
    },
    {
      id_mbe_business: DELIVERY_NEUTRAL_ID,
      name: DELIVERY_NEUTRAL,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_neutral_delivery")
    },
    {
      id_mbe_business: RETURN_PRINT_AND_SEND_ID,
      name: RETURN_PRINT_AND_SEND,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_return_print_and_send")
    },
    {
      id_mbe_business: RETURN_ONE_ATTEMPT_ID,
      name: RETURN_ONE_ATTEMPT,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_return_one_attempt")
    },
    {
      id_mbe_business: RETURN_THREE_ATTEMPTS_ID,
      name: RETURN_THREE_ATTEMPTS,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_return_three_attempts")
    },
    {
      id_mbe_business: RETURN_ELECTRONIC_ID,
      name: RETURN_ELECTRONIC,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_return_electronic")
    },
    {
      id_mbe_business: PRIVATE_HOME_DELIVERY_ID,
      name: PRIVATE_HOME_DELIVERY,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_private_home_delivery")
    },
    {
      id_mbe_business: UPS_CARBON_ID,
      name: UPS_CARBON,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_ups_carbon")
    },
    {
      id_mbe_business: DIRECT_DELIVERY_ONLY_ID,
      name: DIRECT_DELIVERY_ONLY,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("extra_service_direct_delivery_only")
    },
    {
      id_mbe_business: INSURANCE_OTHER_4_ID,
      name: COVER_PROTECT_G,
      has_value: true,
      has_description: false,
      has_payment_type: false,
      value_label: i18n.t("extra_service_cod_value"),
      title: i18n.t("extra_service_cover_protect_g")
    },
    {
      id_mbe_business: INSURANCE_OTHER_5_ID,
      name: COVER_PROTECT_S,
      has_value: true,
      has_description: false,
      has_payment_type: false,
      value_label: i18n.t("extra_service_cod_value"),
      title: i18n.t("extra_service_cover_protect_s")
    },
    {
      id_mbe_business: NOTICE_DELIVERY_E_MAIL_BEFORE_ID,
      name: NOTICE_DELIVERY_E_MAIL_BEFORE,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("notice_delivery_email_before")
    },
    {
      id_mbe_business: MBE_MEASUREMENT_FEE_ID,
      name: MBE_MEASUREMENT_FEE,
      has_value: false,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("notice_delivery_email_before")
    },
    {
      id_mbe_business: DRY_ICE_ID,
      name: DRY_ICE,
      has_value: true,
      has_description: false,
      has_payment_type: false,
      title: i18n.t("dry_ice")
    }
  ];

  @Prop() surcharges: ShipmentExtraServiceDTO[];
  @Prop() extraServices: ShipmentExtraServiceDTO[];
  @Prop() edition: boolean;
  @Prop() vatPercentage: number;
  @Prop() vatId: number;
  @Prop() vatCode: string;
  @Prop() vatName: string;
  @Prop() currencies: any[];
  @Prop() currency: string;
  @Prop() proforma: ProformaDTO;
  @Prop() paymentTypes: PaymentTypesDTO[];
  @Prop() shipment: ShipmentDTO;
  @Prop() sv4bMin: number;
  @Prop() sv4bMax: number;
  @Prop() sv4bValue: number;
  @Prop() sv4bCoverage: boolean;
  @Prop() removeCOD: boolean;
  @Prop() removeEssential: boolean;
  accordionOpened = false;
  userSelected = {} as any; //map businessid + boolean, populate if user manually selects or deselect a service, not persisted

  // Validations -- This functions are called from the outside to check errors
  validateExtraService(service_name: string): boolean {
    if (store.getters["customer/extraServiceConfig"] !== null) {
      if (this.removeEssential) {
        this.definedExtraServices = this.definedExtraServices.filter(
          ex => ex.name !== MBE_SAFE_VALUE_ESSENTIAL
        );
      }
      const targetES = this.definedExtraServices.find(
        e => e.name === service_name
      );
      if (!targetES) {
        return true;
      }
      if (this.isSelected(targetES)) {
        if (
          service_name === MBE_SAFE_VALUE ||
          service_name === COD ||
          service_name === INSURANCE_COURIER ||
          service_name === MBE_SAFE_VALUE_ESSENTIAL
        ) {
          const value = Number(this.get_value(targetES));
          let id = 0;
          switch (service_name) {
            case MBE_SAFE_VALUE:
              id = 1;
              break;
            case MBE_SAFE_VALUE_ESSENTIAL:
              id = 332;
              break;
            case COD:
              id = 2;
              break;
            case INSURANCE_COURIER:
              id = 3;
              break;
          }

          const extraServiceMaxValue = CustomerService.getExtraServiceMaxValue(
            id
          );

          return extraServiceMaxValue === 0 || value <= extraServiceMaxValue;
        } else if (service_name === PREDICT_SMS_DPD) {
          if (this.shipment !== undefined) {
            return this.shipment.addressTo.phone !== "";
          } else {
            return false;
          }
        } else if (service_name === PREDICT_EMAIL_DPD) {
          if (this.shipment !== undefined) {
            return this.shipment.addressTo.email !== "";
          } else {
            return false;
          }
        }
      }
    }

    return true;
  }
  // \Validations

  created() {
    if (this.anySelected) {
      this.accordionOpened = true;
    }
  }

  get anySelected() {
    return this.extraServices.some(
      value => this.getExtraService(value.mbeBusinessId) !== null
    );
  }

  canDoAutoAdd(extraServiceId: number): boolean {
    return (
      this.$store.getters["customer/extraServiceConfig"].some(
        extraServiceConfig =>
          extraServiceConfig.extraServiceId === extraServiceId
      ) && !this.userSelected?.[extraServiceId]
    );
  }

  isSelected(extraServiceItem: any): boolean {
    const extraServiceId = extraServiceItem.id_mbe_business;
    return this.getExtraService(extraServiceId) !== null;
  }

  toggle(extraServiceItem: any) {
    const extraServiceId = extraServiceItem.id_mbe_business;
    this.userSelected[extraServiceId] = true;
    if (this.isSelected(extraServiceItem)) {
      const extraService = this.getExtraService(extraServiceId);
      if (extraService) {
        this.setUserEdited(extraService);
      }
      this.$emit("rm-extraService", extraService);
      this.$emit("recalculatePrice");
    } else {
      const extraService = this.createExtraService(extraServiceId);
      if (extraService) {
        this.setUserEdited(extraService);
      }
      this.$emit("add-extraService", extraService);
      this.$emit("recalculatePrice");
    }
    VueScrollTo.scrollTo(".error", 1500);
  }

  setUserEdited(extraService: ShipmentExtraServiceDTO) {
    extraService.userEditedPrice = true;
    extraService.userEditedCost = true;
  }

  get_value(extraServiceItem: any): string {
    const extraServiceId = extraServiceItem.id_mbe_business;
    const extra_service = this.getExtraService(extraServiceId);
    if (
      extra_service !== null &&
      extra_service.extraServiceValue !== null &&
      extra_service.extraServiceValue !== undefined
    ) {
      return extra_service.extraServiceValue.toFixed(2);
    } else {
      return "0.00";
    }
  }

  get_shipAndPackIncluded() {
    return this.shipment
      .useOtherExtraServiceAndShipmentAndExtraServiceValueForBase;
  }

  set_value(value: string, extraServiceItem: any) {
    const extraServiceId = extraServiceItem.id_mbe_business;
    const extra_service = this.getExtraService(extraServiceId);
    const previousValue = extra_service.extraServiceValue;
    value = value.replace(",", ".");
    extra_service.extraServiceValue = parseFloat(value);
    this.setUserEdited(extra_service);
    if (
      !this.sv4bValueValidation(extra_service.extraServiceValue, extraServiceId)
    ) {
      this.$alerts.danger(
        i18n.t("SAFE_VALUE_4B_EXTRA_SERVICE_OUTSIDE_CUSTOM_RANGE", {
          currencySymbol: (this as any).mbeCurrencySymbol,
          minVal: (this as any).sv4bMin,
          maxVal: (this as any).sv4bMax
        })
      );
      this.$nextTick(() => {
        extra_service.extraServiceValue = previousValue;
      });
    } else if (
      extra_service !== null &&
      extra_service.extraServiceValue !== undefined
    ) {
      this.$emit("recalculatePrice");
    }
  }

  sv4bValueValidation(value, idMbeBusiness) {
    if (idMbeBusiness !== 300) return true;
    if (value < this.sv4bMin || value > this.sv4bMax) return false;
    return true;
  }

  get_description(extraServiceItem: any): string {
    const extraServiceId = extraServiceItem.id_mbe_business;
    const extra_service = this.getExtraService(extraServiceId);
    if (
      extra_service !== null &&
      extra_service.extraServiceValue !== undefined
    ) {
      //return extra_service.???
    }
    return "";
  }

  set_description(description: string, extraServiceItem: any) {
    const extraServiceId = extraServiceItem.id_mbe_business;
    const extra_service = this.getExtraService(extraServiceId);
    if (
      extra_service !== null &&
      extra_service.extraServiceValue !== undefined
    ) {
      //extra_service.extraServiceValue = parseFloat(value)
      //this.$emit('recalculatePrice')
    }
  }

  get_payment_type(extraServiceItem: any): PaymentTypesDTO | null {
    const extraServiceId = extraServiceItem.id_mbe_business;
    const extra_service = this.getExtraService(extraServiceId);
    if (
      extra_service !== null &&
      this.paymentTypes !== null &&
      this.paymentTypes.length > 0
    ) {
      const filteredPaymentTypes = this.paymentTypes.filter(
        (item: PaymentTypesDTO) => {
          if (extra_service !== null) {
            return (
              item.extraServicePaymentTypeId ===
              extra_service.extraServiceTypeId
            );
          } else {
            return false;
          }
        }
      );

      if (filteredPaymentTypes.length > 0) {
        return filteredPaymentTypes[0];
      }
    }

    return null;
  }

  set_payment_type(
    payment_type: PaymentTypesDTO | null,
    extraServiceItem: any
  ) {
    const extraServiceId = extraServiceItem.id_mbe_business;
    const extra_service = this.getExtraService(extraServiceId);
    if (extra_service !== null && payment_type !== null) {
      this.setUserEdited(extra_service);
      extra_service.extraServiceTypeId = payment_type.extraServicePaymentTypeId;
      if (
        payment_type.description !== undefined &&
        payment_type.description !== ""
      ) {
        extra_service.extraServiceTypeName = String(
          this.$t(payment_type.description)
        );
      } else {
        extra_service.extraServiceTypeName = payment_type.paymentType;
      }
      if (payment_type.extraServiceTypeList.length > 0) {
        extra_service.extraServiceTypeInternalCode =
          payment_type.extraServiceTypeList[0].internalCode;
      }
    }

    if (extra_service !== null && payment_type == null) {
      extra_service.extraServiceTypeId = 0;
      extra_service.extraServiceTypeName = "";
      extra_service.extraServiceTypeInternalCode = "";
    }
  }

  isSurchargeAllowed(surchargeItem: any) {
    // for autopilot shipments remove COD extra service if not allowed by courier
    if (this.removeCOD && surchargeItem.id_mbe_business === 2) {
      return false;
    }

    const surchargeId = surchargeItem.id_mbe_business;
    if (this.surcharges !== null) {
      const filtered_surcharges = this.surcharges.filter(
        item => item.mbeBusinessId === surchargeId
      );

      if (filtered_surcharges.length === 1) {
        const surcharge = filtered_surcharges[0];
        if (this.$store.getters["customer/extraServiceConfig"] !== null) {
          let extraServiceIsEnabledForCustomer = false as boolean;
          (this.$store.getters[
            "customer/extraServiceConfig"
          ] as OnlineMBEExtraServiceDto[]).forEach(customerExtraService => {
            if (
              customerExtraService.extraServiceId === surcharge.mbeBusinessId
            ) {
              extraServiceIsEnabledForCustomer = true;
            }
          });
          if (extraServiceIsEnabledForCustomer) {
            if (this.edition) {
              return (
                surcharge.applicableOnPrice &&
                (!this.$store.getters["customer/config"].canSelectCourier ||
                  surcharge.applicableOnCost ||
                  surcharge.extraServiceName === MBE_SAFE_VALUE ||
                  surcharge.extraServiceName === MBE_SAFE_VALUE_ESSENTIAL ||
                  surcharge.extraServiceName === MBE_SAFE_VALUE_4B ||
                  surcharge.price)
              );
            } else {
              return surcharge;
            }
          } else {
            if (
              this.shipment !== undefined &&
              this.$store.getters["customer/config"].tenantId === 3 &&
              this.shipment.courierName === "DPD" &&
              (this.shipment.courierServiceName === "Classic" ||
                this.shipment.courierServiceName === "ClassicSTD") &&
              this.shipment.addressTo.residential &&
              (surcharge.extraServiceName === PREDICT_SMS_DPD ||
                surcharge.extraServiceName === PREDICT_EMAIL_DPD)
            ) {
              return surcharge;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getExtraService(idMbeBusiness: number): ShipmentExtraServiceDTO | null {
    const filteredExtraServices = this.extraServices.filter(
      item => item.mbeBusinessId === idMbeBusiness && item.price
    );

    if (filteredExtraServices.length > 0) {
      return filteredExtraServices[0];
    } else {
      return null;
    }
  }

  createExtraService(idMbeBusiness: number): ShipmentExtraServiceDTO | null {
    const filtered_surcharges = this.surcharges.filter(
      item => item.mbeBusinessId === idMbeBusiness
    );
    return this.createExtraServiceFromShipmentExtraServiceDTO(
      filtered_surcharges?.[0]
    );
  }

  createExtraServiceFromShipmentExtraServiceDTO(
    shipmentExtraServiceDTO: ShipmentExtraServiceDTO
  ): ShipmentExtraServiceDTO | null {
    if (shipmentExtraServiceDTO) {
      const extraService = {
        vatId: this.vatId,
        vatCode: this.vatCode,
        vatName: this.vatName,
        vatPercentage: this.vatPercentage,
        safeValueDocument: null,
        price: shipmentExtraServiceDTO.applicableOnPrice,
        cost: shipmentExtraServiceDTO.applicableOnCost,
        ...shipmentExtraServiceDTO
      } as ShipmentExtraServiceDTO;
      extraService.price = shipmentExtraServiceDTO.applicableOnPrice;

      if (name === MBE_SAFE_VALUE || name === COD) {
        extraService.extraServiceValue = 0;
      }

      if (name === COD) {
        extraService.extraServiceTypeId = 0;
        extraService.extraServiceTypeName = "";
        extraService.extraServiceTypeInternalCode = "";
      }

      // Testing
      if (extraService.extraServiceName === undefined) {
        extraService.extraServiceName = "";
      }
      if (extraService.mbeBusinessId === undefined) {
        extraService.mbeBusinessId = 0;
      }
      const isExtraServiceTypeIdNeeded =
        this.definedExtraServices
          .filter(ex => ex.has_payment_type)
          .filter(ex => ex.id_mbe_business === extraService.mbeBusinessId)
          .length !== 0;
      if (
        extraService.extraServiceTypeId === undefined &&
        isExtraServiceTypeIdNeeded
      ) {
        extraService.extraServiceTypeId = 0;
      }
      if (extraService.extraServiceTypeName === undefined) {
        extraService.extraServiceTypeName = "";
      }
      if (extraService.extraServiceTypeInternalCode === undefined) {
        extraService.extraServiceTypeInternalCode = "";
      }
      if (
        extraService.paymentType === undefined &&
        this.hasExtraServicePaymentType(extraService)
      ) {
        extraService.paymentType = "OTHER";
      }
      if (extraService.autoAdded === undefined) {
        extraService.autoAdded = false;
      }
      if (extraService.autoApplyCost === undefined) {
        extraService.autoApplyCost = false;
      }
      if (extraService.autoApplyPrice === undefined) {
        extraService.autoApplyPrice = false;
      }
      if (extraService.price === undefined) {
        extraService.price = false;
      }
      if (extraService.cost === undefined) {
        extraService.cost = false;
      }
      if (extraService.vatId === undefined) {
        extraService.vatId = 0;
      }
      if (extraService.vatName === undefined) {
        extraService.vatName = "";
      }
      if (extraService.vatCode === undefined) {
        extraService.vatCode = "";
      }
      if (extraService.vatPercentage === undefined) {
        extraService.vatPercentage = 0;
      }
      if (extraService.netCost === undefined) {
        extraService.netCost = 0;
      }
      if (extraService.grossCost === undefined) {
        extraService.grossCost = 0;
      }
      if (extraService.netPrice === undefined) {
        extraService.netPrice = 0;
      }
      if (extraService.grossPrice === undefined) {
        extraService.grossPrice = 0;
      }
      if (extraService.userNetPrice === undefined) {
        extraService.userNetPrice = 0;
      }
      if (extraService.userGrossPrice === undefined) {
        extraService.userGrossPrice = 0;
      }
      if (extraService.userNetCost === undefined) {
        extraService.userNetCost = 0;
      }
      if (extraService.userGrossCost === undefined) {
        extraService.userGrossCost = 0;
      }
      if (extraService.courierExtraServiceTierName === undefined) {
        extraService.courierExtraServiceTierName = "";
      }

      const currency = this.$store.getters["customer/storeInfo"].store.currency;
      if (extraService.currencyId === undefined) {
        extraService.currencyId = this.getCurrencyIdFromCurrency(currency);
      }
      if (extraService.currency === undefined) {
        extraService.currency = currency;
      }

      if (extraService.extraServiceValue === undefined) {
        extraService.extraServiceValue = 0;
      }
      if (extraService.extraServiceTypeNameFromImport === undefined) {
        extraService.extraServiceTypeNameFromImport = "";
      }
      if (extraService.surcharge === undefined) {
        extraService.surcharge = false;
      }
      if (extraService.surchargeType === undefined) {
        extraService.surchargeType = undefined;
      }
      if (extraService.vatEditableByUser === undefined) {
        extraService.vatEditableByUser = false;
      }
      if (extraService.vatEditableByCustomer === undefined) {
        extraService.vatEditableByCustomer = false;
      }
      if (extraService.visibilityType === undefined) {
        extraService.visibilityType = "STANDARD";
      }
      if (extraService.profitId === undefined) {
        extraService.profitId = 0;
      }
      if (extraService.profitName === undefined) {
        extraService.profitName = "";
      }
      if (extraService.applicableOnCost === undefined) {
        extraService.applicableOnCost = false;
      }
      if (extraService.applicableOnPrice === undefined) {
        extraService.applicableOnPrice = false;
      }
      if (extraService.isUserPrice === undefined) {
        extraService.isUserPrice = false;
      }
      if (extraService.isUserCost === undefined) {
        extraService.isUserCost = false;
      }
      if (extraService.calculatedBaseValue === undefined) {
        extraService.calculatedBaseValue = 0;
      }
      if (extraService.order === undefined) {
        extraService.order = 0;
      }
      if (extraService.nationalBankAccountNumber === undefined) {
        extraService.nationalBankAccountNumber = "";
      }
      if (extraService.iscGoodId === undefined) {
        extraService.iscGoodId = "";
      }

      if (
        extraService.mbeBusinessId == 300 &&
        extraService.extraServiceValue == 0
      ) {
        extraService.extraServiceValue = this.sv4bValue;
      }
      return extraService;
    } else {
      return null;
    }
  }

  getCurrencyIdFromCurrency(currency: string) {
    const selectedCurrencies = this.currencies.filter(item => {
      return item.code === currency;
    });

    return selectedCurrencies.length > 0 ? selectedCurrencies[0].id : 0;
  }

  isInsuranceConflict(definedExtraService: any) {
    if (definedExtraService.id_mbe_business === 1) {
      return (
        this.isSelected({ id_mbe_business: 3 }) ||
        this.isSelected({ id_mbe_business: 300 }) ||
        this.isSelected({ id_mbe_business: 332 })
      );
    }
    if (definedExtraService.id_mbe_business === 3) {
      return (
        this.isSelected({ id_mbe_business: 1 }) ||
        this.isSelected({ id_mbe_business: 300 }) ||
        this.isSelected({ id_mbe_business: 332 })
      );
    }
    if (definedExtraService.id_mbe_business === 300) {
      return (
        this.isSelected({ id_mbe_business: 3 }) ||
        this.isSelected({ id_mbe_business: 1 }) ||
        this.isSelected({ id_mbe_business: 332 })
      );
    }
    if (definedExtraService.id_mbe_business === 332) {
      return (
        this.isSelected({ id_mbe_business: 3 }) ||
        this.isSelected({ id_mbe_business: 1 }) ||
        this.isSelected({ id_mbe_business: 300 })
      );
    }
    return false;
  }

  get showServicesAccordion() {
    if (this.edition) {
      return true;
    } else {
      return this.definedExtraServices.some(value =>
        this.isSurchargeAllowed(value)
      ); //any requested previously+ visible permission etc.
    }
  }

  hasExtraServicePaymentType(extraService) {
    return extraService.visibilityType === "VALUE_CURRENCY_PAYMENT_TYPE";
  }

  toggleShipAndPack() {
    this.$emit("toggleShipAndPack");
  }

  resetPaymentType(extsvc: any) {
    if (!(this.$parent.$parent as NewShipment).isSavePressed) {
      this.set_payment_type(null, extsvc);
    }
  }
}
